(function() {

  // Async CSS
  var cb = function() {
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = '/typo3conf/ext/jo_modellbau_distribution/Resources/Public/Css/async.css';
    //l.href = 'Css/async.css';
    var h = document.getElementsByTagName('head')[0];
    h.parentNode.insertBefore(l, h);
  };
  var raf = requestAnimationFrame || mozRequestAnimationFrame ||
    webkitRequestAnimationFrame || msRequestAnimationFrame;
  if (raf) raf(cb);
  else window.addEventListener('load', cb);

  // Menufixer
  /*var el = document.getElementById("topnavbar");
  var wrapper = document.getElementsByClassName("wrapper")[0];
  var topPos = el.offsetTop;
  var height = parseInt(getComputedStyle(el).height);

  window.onscroll = function() {myFunction()};

  function myFunction() {
      if (document.body.scrollTop > topPos || document.documentElement.scrollTop > topPos) {
          wrapper.style.marginTop = height + "px";
          el.className = "navbar-fixed-top";
      } else {
          wrapper.style.marginTop = 0;
          el.className = "navbar-static-top";
      }
  }*/


  // Example starter JavaScript for disabling form submissions if there are invalid fields
  (function() {
    'use strict';
    if (document.getElementsByClassName("needs-validation")[0] != null) {
      window.addEventListener('load', function() {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');

        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function(form) {
          form.addEventListener('submit', function(event) {
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
            }
            form.classList.add('was-validated');
          }, false);
        });
      }, false);
    }
  })();


  /*
    var stickymenu = document.getElementById("stickymenu"),
    stickymenuoffset = stickymenu.offsetTop,
    scrolltimer;

    window.addEventListener("scroll", function(e){
      requestAnimationFrame(function(){
        if (window.pageYOffset > stickymenuoffset){
          stickymenu.classList.add('sticky');
        }
        else{
          stickymenu.classList.remove('sticky');
        }
      });
    })
  */

})();